export enum ReversalType {
  RENEWAL,
  REGISTRATION
}
